module.exports = __webpack_public_path__ + "static/media/bookings.7179d989.jpg";